import {EElement, ELogicalElement} from '@progress-fe/core';
import {TElementInfoSnapshotIn, TLogicalElementInfoSnapshotIn} from 'core/models';

export const ELEMENTS_SAMPLE_ELEMENTS_LIST: {
  projectId: string;
  projectName: string;
  items: TElementInfoSnapshotIn[];
  logicalItems: TLogicalElementInfoSnapshotIn[];
}[] = [
  {
    projectId: '47CB2F0C-0000-0000-0000-000000000000',
    projectName: 'Элементы (моковый проект)',
    items: [
      {
        uuid: '196C89E0-1111-0000-0000-000000000001',
        type: EElement.HeaterElement,
        name: 'H-100',
        lastUpdated: new Date()
      },
      {
        uuid: '196C89E0-1111-0000-0000-000000000002',
        type: EElement.HeaterElement,
        name: 'H-101',
        lastUpdated: new Date()
      },
      {
        uuid: '196C89E0-1111-0000-0000-000000000003',
        type: EElement.PipelineElement,
        name: 'T-100',
        lastUpdated: new Date()
      }
    ],
    logicalItems: [
      {
        uuid: '196C89E0-2222-2222-2222-000000000001',
        logicalType: ELogicalElement.Function,
        name: 'F-100',
        lastUpdated: new Date()
      },
      {
        uuid: '196C89E0-2222-2222-2222-000000000002',
        logicalType: ELogicalElement.Optimization,
        name: 'O-100',
        lastUpdated: new Date()
      }
    ]
  }
];
